module.exports = __webpack_public_path__ + "static/media/rewards-icon.86f05b21.svg";